import { MAP_ELEMENT_TYPES } from '../../../../constants/graph';
import MapElementModal from '../../../graph/MapElementModal';
import screens from '../common/screens';
import {
    MapElementProvider,
    type MapElementProviderProps,
} from '../contextProviders/MapElementProvider';
import { OpenApiProvider } from '../contextProviders/OpenApiProvider';
import OpenApiRouter from './OpenApiRouter';
/**
 * The openapi config screen
 */
const OpenApi = (props: MapElementProviderProps) => {
    return (
        <MapElementProvider
            {...props}
            defaultScreen={screens.openApi}
            elementType={MAP_ELEMENT_TYPES.openapi}
        >
            <MapElementModal>
                <OpenApiProvider defaultScreen={screens.openApi}>
                    <OpenApiRouter />
                </OpenApiProvider>
            </MapElementModal>
        </MapElementProvider>
    );
};

export default OpenApi;
